import { Grid, ListSubheader, Paper, Avatar } from '@mui/material';
import React from 'react';
import { useRelativeConditionIndexDetail } from '../../data/DataProviders/RelativeConditionIndexProvider';
import { Icon } from '../../lib/icons';
import { isDataLoaded } from '../../types';
import { DataIndicators } from '../DataIndicators';
import { useStyles } from './styles';


export const RelativeConditionIndex: React.FC = () => {
    const responseRCI = useRelativeConditionIndexDetail();
    const isEmpty = isDataLoaded(responseRCI) ? responseRCI.value.data.length === 0 : false;
    const classes = useStyles();
    const conditionStyle = (rankColor: string, cls: any): void => {
        switch (rankColor) {
            case 'Yellow':
                return cls.Yellow;
            case 'Red':
                return cls.Red;
            case 'Green':
                return cls.Green;
            case 'Grey':
                return cls.Grey;
            default:
        }
    };

    return (
        <div data-testid="relative-status" style={{ border: '1px solid #dfe1e1', borderRadius: '5px' }}>
        <Paper elevation={0} style={{ border: '0px' }}>
            <ListSubheader
                color="primary"
                component="div"
                style={{ fontWeight: 600, borderBottom: '1px solid #dbdbdb' }}
            >
                Relative Condition Index
                <span className={classes.iconAlignment}>{<Icon.Info className={classes.iconStyle} />}</span>
            </ListSubheader>

            <DataIndicators
                errorMessage="Record not found"
                emptyMessage="Record not found"
                data={responseRCI}
                emptyIcon="BarChart"
                isEmpty={isEmpty}
                isDetailedInfo={false}
            />

            <Grid container direction="row" alignItems="center" justifyContent="center">
                {isDataLoaded(responseRCI) && (
                    <>
                        {responseRCI.value.data.length > 0 && (
                            <>
                                {responseRCI.value.data.map((element: any, index) => (
                                    <Grid key={index} xs={2} item style={{ padding: '40px 40px' }}>
                                        <>
                                            <Avatar
                                                className={`${classes.relAvatar} ${conditionStyle(
                                                    element.rankColor,
                                                    classes
                                                )}`}
                                            >
                                                {element.rankPercentage === '--' ? (<>--</>) : <>{Number(element.rankPercentage).toFixed()}%</>}
                                            </Avatar>
                                            <div style={{ fontWeight: 600 }}>{element.monthAndYear}</div>
                                        </>
                                    </Grid>
                                ))}
                            </>
                        )}
                    </>
                )}
            </Grid>
        </Paper>
        </div>
    );
};
